module.exports = __webpack_public_path__ + "static/media/kw1200 blue.20ea61ba.jpg";